import { QUERY_KEYS } from "@/libraries/constant";
import type { ResError } from "@/types";
import { useMutation } from "@tanstack/react-query";

function useCloseGroup() {
	return useMutation<any, ResError, any>({
		mutationKey: [QUERY_KEYS.MUTATE_GROUP_CLOSE],
	});
}

export default useCloseGroup;
